import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { randomBytes } from 'crypto';
var getNextHeaders = function () {
  var _ref = _asyncToGenerator(function* () {
    if (typeof window !== 'undefined') return null;
    try {
      var _yield$import = yield import('next/headers'),
        headers = _yield$import.headers;
      return headers;
    } catch (_unused) {
      return null;
    }
  });
  return function getNextHeaders() {
    return _ref.apply(this, arguments);
  };
}();
export var getLocalhostHeadersAsync = function () {
  var _ref2 = _asyncToGenerator(function* (isServerSide) {
    var _host;
    var host;
    try {
      if (isServerSide) {
        var headersFn = yield getNextHeaders();
        if (headersFn) {
          var _yield$headersFn$get;
          host = (_yield$headersFn$get = (yield headersFn()).get('host')) !== null && _yield$headersFn$get !== void 0 ? _yield$headersFn$get : '';
        }
      } else if (typeof window !== 'undefined') {
        var _window;
        host = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host;
      }
    } catch (_unused2) {
      return {};
    }
    var isLocalhost = (_host = host) === null || _host === void 0 ? void 0 : _host.includes('localhost');
    if (isLocalhost) {
      return _objectSpread(_objectSpread({}, isServerSide && {
        Referer: "http://".concat(host, "/")
      }), {}, {
        'X-Dev-Nonce': randomBytes(16).toString('base64')
      });
    }
    return {};
  });
  return function getLocalhostHeadersAsync(_x) {
    return _ref2.apply(this, arguments);
  };
}();